class TrudoorProductCutToSize extends HTMLElement {
  connectedCallback() {
    this.initializeElements();
    this.bindEvents();
  }

  initializeElements() {
    this.widthInput = this.querySelector("input#width_needed");
    this.heightInput = this.querySelector("input#length_needed");
    this.totalAreaElement = this.querySelector(".wc-measurement-price-calculator-total-amount");
    this.productPriceElement = this.querySelector(".product_price .amount");
    this.addToCartButtons = this.querySelectorAll(".pdp-add-to-cart");
    this.errorMessage = document.createElement("p");
    this.errorMessage.className = "error";

    this.pricePerSqFt = parseFloat(this.dataset.pricePerSqFt);
    this.glassWeight = this.dataset.glassWeight.trim();
    this.glassThickness = this.dataset.glassThickness.replace("&quot;", '"').trim();

    this.addToCartButtons.forEach((button) => {
      button.textContent = `ADD TO CART`;
      button.value = `ADD TO CART`;
    });
  }

  bindEvents() {
    if (!this.widthInput || !this.heightInput) return;

    const handleInput = () => this.calculateTotalAreaAndPrice();
    this.widthInput.addEventListener("input", handleInput);
    this.heightInput.addEventListener("input", handleInput);
  }

  calculateTotalAreaAndPrice() {
    const width = parseFloat(this.widthInput.value);
    const height = parseFloat(this.heightInput.value);

    if (isNaN(width) || isNaN(height) || isNaN(this.pricePerSqFt)) {
      this.totalAreaElement.textContent = "0.000";
      this.productPriceElement.textContent = "$0.00";
      return;
    }

    const totalArea = (width * height) / 144;
    const totalPrice = totalArea * this.pricePerSqFt;
    const formattedPrice = `$${totalPrice.toFixed(2)}`;

    this.totalAreaElement.textContent = totalArea.toFixed(3);
    this.productPriceElement.textContent = formattedPrice;
    this.addToCartButtons.forEach((button) => {
      button.textContent = `ADD TO CART | ${formattedPrice}`;
      button.value = `ADD TO CART | ${formattedPrice}`;
    });
  }

  validate() {
    const width = parseFloat(this.widthInput.value);
    const height = parseFloat(this.heightInput.value);

    const widthMin = parseFloat(this.widthInput.min);
    const widthMax = parseFloat(this.widthInput.max);
    const heightMin = parseFloat(this.heightInput.min);
    const heightMax = parseFloat(this.heightInput.max);

    const widthDecimalPart = width % 1;
    const heightDecimalPart = height % 1;

    if (
      width < widthMin ||
      width > widthMax ||
      height < heightMin ||
      height > heightMax ||
      (!Number.isInteger(width) && !this.isValidDecimal(widthDecimalPart)) ||
      (!Number.isInteger(height) && !this.isValidDecimal(heightDecimalPart))
    ) {
      this.errorMessage.textContent = "Invalid width or height values.";
      this.querySelector("form.cart").appendChild(this.errorMessage);
      return false;
    }

    this.errorMessage.textContent = "";
    return true;
  }

  getCartData(quantity) {
    if (!this.validate()) return null;

    const width = parseFloat(this.widthInput.value);
    const height = parseFloat(this.heightInput.value);
    const variantId = parseInt(this.dataset.variantId, 10);

    if (!variantId) return null;

    const cartData = {
      id: variantId,
      quantity: parseInt(quantity, 10),
      properties: {
        SKU: this.dataset.sku,
        "Usually Ships": this.dataset.usuallyShips,
        Dimensions: `${this.convertToFractional(width)} x ${this.convertToFractional(height)}`,
        _width: width,
        _height: height,
        _glass_weight: this.glassWeight,
        _glass_thickness: this.glassThickness,
      },
    };

    return cartData;
  }

  isValidDecimal(decimal) {
    const validDecimals = [
      0.0625, 0.125, 0.1875, 0.25, 0.3125, 0.375, 0.4375, 0.5, 0.5625, 0.625, 0.6875, 0.75, 0.8125, 0.875, 0.9375,
    ];
    return validDecimals.includes(decimal);
  }

  convertToFractional(value) {
    const fractions = [
      "1/16",
      "1/8",
      "3/16",
      "1/4",
      "5/16",
      "3/8",
      "7/16",
      "1/2",
      "9/16",
      "5/8",
      "11/16",
      "3/4",
      "13/16",
      "7/8",
      "15/16",
    ];
    const validDecimals = [
      0.0625, 0.125, 0.1875, 0.25, 0.3125, 0.375, 0.4375, 0.5, 0.5625, 0.625, 0.6875, 0.75, 0.8125, 0.875, 0.9375,
    ];

    const integerPart = Math.floor(value);
    const decimalPart = value - integerPart;

    if (decimalPart === 0) return `${integerPart}"`;

    const closestFraction = validDecimals.find((v) => Math.abs(v - decimalPart) < 0.0001);
    if (!closestFraction) return `${integerPart}"`;

    const fractionString = fractions[validDecimals.indexOf(closestFraction)];
    return integerPart > 0 ? `${integerPart}-${fractionString}"` : `${fractionString}"`;
  }

  reset() {
    this.widthInput.value = "";
    this.heightInput.value = "";
    this.calculateTotalAreaAndPrice();
    this.errorMessage.textContent = "";
  }
}

customElements.define("trudoor-product-cut-to-size", TrudoorProductCutToSize);
